// Privacy-conscious analytics preparation.
// Event names only — NEVER pass names, emails, phone numbers, free-text
// messages or other personal data. A real provider can be wired in later
// without touching call sites.
const ALLOWED_EVENTS = new Set([
  'contact_hero_booking_click',
  'contact_hero_enquiry_click',
  'enquiry_started',
  'enquiry_submitted',
  'booking_started',
  'meeting_type_selected',
  'date_selected',
  'booking_confirmed',
  'booking_cancelled',
  'booking_rescheduled',
  'compass_page_viewed',
  'compass_explore_click',
  'compass_feature_viewed',
  'compass_demo_click',
  'compass_pricing_click',
  'compass_login_click',
  'compass_related_case_study',
  'compass_related_insight',
  'pulse_page_viewed',
  'pulse_explore_click',
  'pulse_feature_viewed',
  'pulse_demo_click',
  'pulse_pricing_click',
  'pulse_login_click',
  'pulse_related_case_study',
  'pulse_related_insight',
  'foresee_page_viewed',
  'foresee_explore_click',
  'foresee_workflow_viewed',
  'foresee_module_viewed',
  'foresee_demo_click',
  'foresee_pricing_click',
  'foresee_login_click',
  'foresee_related_case_study',
  'foresee_related_insight',
  'reach_page_viewed',
  'reach_explore_click',
  'reach_module_viewed',
  'reach_demo_click',
  'reach_pricing_click',
  'reach_login_click',
  'reach_related_case_study',
  'reach_related_insight',
  'systems_showcase_tab_selected',
  'systems_showcase_explore_click',
  'case_study_view',
  'case_study_gallery_open',
  'page_view',
]);

// Anonymous, cookieless first-party counting — event name, page path and
// referrer hostname only (consistent with the site's no-tracking-cookies
// policy). Fire-and-forget via sendBeacon; never blocks UX.
const beacon = (name) => {
  try {
    let ref = '';
    if (document.referrer) {
      const host = new URL(document.referrer).hostname;
      if (host && host !== window.location.hostname) ref = host;
    }
    const body = JSON.stringify({ event: name, path: window.location.pathname, ref });
    navigator.sendBeacon(
      `${process.env.REACT_APP_BACKEND_URL}/api/public/analytics/event`,
      new Blob([body], { type: 'application/json' })
    );
  } catch {
    /* analytics must never break the page */
  }
};

export function trackEvent(name) {
  if (!ALLOWED_EVENTS.has(name)) return;
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.debug(`[analytics] ${name}`);
  }
  beacon(name);
}
